import { render } from "./SobreGramos.vue?vue&type=template&id=4b3f917b&scoped=true"
import script from "./SobreGramos.vue?vue&type=script&lang=js"
export * from "./SobreGramos.vue?vue&type=script&lang=js"

import "./SobreGramos.vue?vue&type=style&index=0&id=4b3f917b&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3f917b"]])

export default __exports__